import { COUNTRY_CODES } from '@savgroup-front-common/constants';
import {
  MARKETING_OFFER_TYPE,
  StrictAutocompleteOptionForHookForm,
} from '@savgroup-front-common/types';
import { RefundMethods } from '@/api/Seller/getRefundMethodsBySellerQuery';
import { getMarketingOfferTypeMessage } from '@/view/components/FileInfoNewUi/helpers';

interface AdaptRefundMethodsToAutocompleteArgs {
  refundMethods?: RefundMethods[];
  countryCode?: string;
}

const adaptRefundMethodsToAutocomplete = ({
  refundMethods,
  countryCode = COUNTRY_CODES.FR,
}: AdaptRefundMethodsToAutocompleteArgs):
  | StrictAutocompleteOptionForHookForm<MARKETING_OFFER_TYPE>[]
  | undefined => {
  if (!refundMethods) {
    return undefined;
  }

  return refundMethods.map((method) => {
    const translatedMethod = method.translationByCountryCode?.find(
      (translation) => translation.cultureCode === countryCode,
    );

    return {
      value: method.marketingOfferType,
      label:
        translatedMethod?.label ||
        getMarketingOfferTypeMessage({
          marketingOfferType: method.marketingOfferType,
        }),
      data: method.marketingOfferType,
    };
  });
};

export default adaptRefundMethodsToAutocomplete;
